import { AnyAction } from "redux";

import { AppState } from "../App";

import { RECEIVE_ORGANISATIONS, ReceiveOrganisationsAction } from "./session";

type SelectedStartScreenOptions = {
  selectedOrganisation: string | null;
};

const INITIAL_STATE: SelectedStartScreenOptions = {
  selectedOrganisation: null,
};

export const getSelectedOrganisation = (state: AppState) =>
  state.selectedStartScreenOptions.selectedOrganisation;

const SET_SELECTED_ORGANISATION = "SelectedStartScreenOptions/SET_SELECTED_ORGANISATION";

export const setSelectedOrganisation = (uniqueId: string | null) => ({
  type: SET_SELECTED_ORGANISATION,
  uniqueId,
});

export default function reducer(
  state = INITIAL_STATE,
  action: AnyAction
): SelectedStartScreenOptions {
  switch (action.type) {
    case RECEIVE_ORGANISATIONS: {
      // This is normally handled in the session reducer, but we select an initial organisation here
      const receivedOrganisations = (action as ReceiveOrganisationsAction).organisations;

      // If there is only one organisation, select it. Don't select the first if there are more,
      // as this is error prone (https://github.com/nens/threedi-live-site/issues/840).
      if (receivedOrganisations.length === 1) {
        const uniqueId = receivedOrganisations[0].uniqueId;
        return {
          ...state,
          selectedOrganisation: uniqueId,
        };
      }

      return state;
    }
    case SET_SELECTED_ORGANISATION: {
      return {
        ...state,
        selectedOrganisation: action.uniqueId,
      };
    }
    default:
      return state;
  }
}
